import {
  getSignaturePlans,
  getSignatures,
  patchSignature,
  postSignatures,
} from '../api/bernabeu';

import { toast } from 'react-toastify';
import {
  callTypes,
  signatureSlice
} from "../../redux/reducers/signatureSlice";

const { actions } = signatureSlice;

const fetchSignatures = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getSignatures({}).then((response: any) => {
      dispatch(actions.signaturesFetched());

      resolve(response.data);
    }).catch((error) => {
      console.log('fetchSignatures falhou:');
      console.log({error});

      dispatch(actions.signaturesFetched());
      reject(new Error('Erro ao buscar assinaturas'));
    });
  });
}

const fetchSignature = (id) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getSignatures({ id: id }).then((response: any) => {
      resolve(response.data[0]);

      dispatch(actions.signaturesFetched());
    }).catch((error) => {
      console.log('fetchCreditPurchases falhou:');
      console.log({error});
      dispatch(actions.signaturesFetched());

      reject(new Error('Erro ao buscar assinatura'));
    });
  });
}

const fetchSignaturePlans = (branchId, couponId = null) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    let params: any = {};

    if (couponId) {
      params.coupon_id = couponId;
    }

    getSignaturePlans(branchId, params).then((response: any) => {
      console.log(response);

      resolve(response.data);

      dispatch(actions.signaturesFetched());

    }).catch((error) => {
      console.log('fetchSignaturePlans falhou:');
      console.log({error});

      dispatch(actions.signaturesFetched());

      reject(new Error('Erro ao buscar planos de assinatura'));
    });
  });
}

const createSignature = (branchId, planId, paymentMethod, metadata = {}, clientCardId = null, couponId = null, autoRenew = null) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    let params: any = {
      plan_id: planId,
      payment_method: paymentMethod,
      metadata: metadata,
    };

    if (clientCardId) {
      params.client_card_id = clientCardId;
    }

    if (couponId) {
      params.coupon_id = couponId;
    }

    if (autoRenew) {
      params.auto_renew = autoRenew;
    }

    postSignatures(branchId, params).then((response: any) => {
      dispatch(actions.signaturesCreated());

      resolve(response);
    }).catch((error) => {
      console.log('createSignature falhou:');
      console.log({error});

      dispatch(actions.signaturesFetched());

      let message = error.response?.data?.message ?? 'Erro ao realizar pagamento da assinatura';

      toast.error(message)

      reject(new Error(message));
    });
  });
}

const updateSignature = (id, clientCardId) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    let params: any = {};

    if (clientCardId) {
      params.client_card_id = clientCardId;
    }

    patchSignature(id, params).then((response: any) => {
      dispatch(actions.signaturesCreated());

      resolve(response);
    }).catch((error) => {
      console.log('updateSignature falhou:');
      console.log({error});

      dispatch(actions.signaturesFetched());

      let message = error.response?.data?.message ?? 'Erro ao realizar pagamento da assinatura';

      toast.error(message)

      reject(new Error(message));
    });
  });
}

export {
  createSignature,
  fetchSignature,
  fetchSignaturePlans,
  fetchSignatures,
  updateSignature
};
